import type { ReactNode } from "react";

interface KpiCardProps {
  label: string;
  value: ReactNode;
  /** Se true, il valore viene colorato con l'accent (utile per richiamare
   *  metriche che richiedono attenzione: pending, queue length, ecc). */
  accent?: boolean;
  hint?: string;
}

/**
 * KPI tile per la dashboard. Compatto, valore monospaced per allineare le cifre.
 *
 * Esempio:
 *   <KpiCard label="Markets aperti" value={kpi.markets_open} />
 *   <KpiCard label="Pending" value={kpi.pending} accent hint="Da risolvere" />
 */
export function KpiCard({ label, value, accent, hint }: KpiCardProps) {
  return (
    <div className="card">
      <div className="text-[11px] uppercase tracking-wider text-muted mb-2">
        {label}
      </div>
      <div
        className={`font-mono text-[28px] font-semibold leading-none ${
          accent ? "text-accent" : "text-text"
        }`}
      >
        {value}
      </div>
      {hint && (
        <div className="mt-2 text-[11.5px] text-muted">{hint}</div>
      )}
    </div>
  );
}
